import api from '../api';
import ranchApi from '../ranchApi';

export const updateFieldStatus = async (body = {}) => {
  try {
    const { data = [] } = await ranchApi.patch('/updateStatus', body);
    return data;
  } catch (error) {
    console.log(JSON.stringify(error), 'error');
    throw error;
  }
};

export const submitQuestionaire = async (body = {}) => {
  try {
    const { data = [] } = await ranchApi.post('/submitQuestionnaire', body);
    return data;
  } catch (error) {
    console.log(JSON.stringify(error), 'error');
    throw error;
  }
};

export const editDocument = async (body = {}) => {
  try {
    const { data } = await ranchApi.patch('/editDocument', body);
    return data;
  } catch (error) {
    console.log(JSON.stringify(error), 'error');
    throw error;
  }
};

export const deleteDocument = async (body = {}) => {
  try {
    const { data } = await ranchApi.delete('/deleteDocument', {
      data: body
    });
    return data;
  } catch (error) {
    console.log(JSON.stringify(error), 'error');
    throw error;
  }
};

export const addProducerByPartner = async (body = {}) => {
  try {
    const { data } = await ranchApi.post('/addProducerByPartner', body);
    return data;
  } catch (error) {
    console.log(JSON.stringify(error), 'addProducerByPartner error');
    throw error;
  }
};

export const addField = async (body = {}) => {
  try {
    const { data } = await ranchApi.post('/addField', body);
    return data;
  } catch (error) {
    console.log(JSON.stringify(error), 'addField error');
    throw error;
  }
};

export const editRanch = async (body = {}) => {
  try {
    const { data } = await ranchApi.put('/EditRanchData', body);
    return data;
  } catch (error) {
    console.log(JSON.stringify(error), 'editRanch error');
    throw error;
  }
};

/**
 * Update farmer bank verification status
 * 
 * @param {Object} params
 * @param {string} params.farmerId - UUID of the farmer
 * @param {string} params.status - new status (e.g. 'BANK_DOCUMENT_VERIFIED')
 * @param {string} params.documentType - document type (e.g. 'CANCELLED_CHEQUE')
 * 
 * @returns {Promise<Object>} API response
 */
export const putFarmerBankStatus = async ({ farmerId, status, documentType }) => {
  if (!farmerId) throw new Error("farmerId is required");

  const response = await api.put(`/bank/farmer/${farmerId}`, {
    status,
    documentType
  });

  return response.data;
};
